import { SettingsBanner } from "./SettingsBanner";

type Initiator = { first_name: string; last_name: string };

type UnenrollmentPendingBannerProps = {
  initiator: Initiator;
  /** "Oct 4, 2026 at 2:15 PM": when the request expires if nobody responds. */
  deadline?: string | null;
  onReview: () => void;
};

const PAUSE_EFFECTS =
  "During the pause, new disbursements can't be created, signatures can't be collected, and co-signers can't be added or removed.";

/**
 * Asks the Owner who did not start the turn-off request to respond.
 *
 * Only Owners can see this banner today: the backend serves the pending
 * request (`GET /multisig/unenrollment`) to Owners alone, so the pause hook
 * has nothing to show a Financial Controller. The design's Financial
 * Controller variant comes back once the backend opens that read.
 */
export const UnenrollmentPendingBanner = ({
  initiator,
  deadline,
  onReview,
}: UnenrollmentPendingBannerProps) => {
  const by = `${initiator.first_name} ${initiator.last_name}`.trim();
  const first = initiator.first_name.trim() || by;

  return (
    <SettingsBanner
      variant="warning"
      title="Your response is needed to turn off co-signing"
      actions={[{ label: "Review and respond", onClick: onReview }]}
    >
      {by} started turning off co-signing. It&apos;s paused until you sign or reject, or {first}{" "}
      cancels. {PAUSE_EFFECTS}
      {deadline ? (
        <>
          {" "}
          Respond by <strong>{deadline}</strong>.
        </>
      ) : null}
    </SettingsBanner>
  );
};
